
import React from "react";
import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";
import notFoundImage from "@/assets/404-elf.png";

const NotFound = () => {
  // Add SEO for the 404 page
  useSEO({
    title: "404 - Page Not Found | Elf Letter Bot",
    description: "The page you're looking for could not be found.",
    noIndex: true,
  });

  return (
    <div className="py-16 md:py-24 bg-elfGreen-light">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-elfRed">404 - Page Not Found</h1>
        <p className="text-lg md:text-xl mb-8">
          Oops! It looks like our Christmas elf is having trouble finding this page.
        </p>
        <div className="max-w-md mx-auto mb-8">
          <img
            src={notFoundImage}
            alt="Confused elf with a 404 not found message"
            width="448"
            height="448"
            className="w-full rounded-2xl shadow-lg"
          />
        </div>
        <p className="mb-8 text-lg">
          Don't worry! You can return to our workshop by clicking the button below.
        </p>
        <Link 
          to="/" 
          className="bg-elfRed hover:bg-elfRed-dark text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-300 inline-block"
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
